/**
 * Cola WhatsApp / Knia: pedidos pending para tomar y facturar (como mesa).
 */

function kniaAjaxUrl(win) {
	return (
		win.ajaxurl ||
		(win.POSKN_API_CONFIG && win.POSKN_API_CONFIG.ajaxUrl) ||
		'pos-ajax.php'
	);
}

function kniaNonce(win) {
	return win.posNonce || (win.POSKN_API_CONFIG && win.POSKN_API_CONFIG.posNonce) || '';
}

function kniaTiendaId(win) {
	let tiendaId = 0;
	if (win.posknTiendaSeleccionada && win.posknTiendaSeleccionada.id != null && win.posknTiendaSeleccionada.id !== '') {
		tiendaId = parseInt(win.posknTiendaSeleccionada.id, 10);
	} else if (win.posknUserTienda && win.posknUserTienda.id != null && win.posknUserTienda.id !== '') {
		tiendaId = parseInt(win.posknUserTienda.id, 10);
	}
	return Number.isNaN(tiendaId) ? 0 : tiendaId;
}

function escapeHtml(text) {
	return String(text || '')
		.replace(/&/g, '&amp;')
		.replace(/</g, '&lt;')
		.replace(/>/g, '&gt;')
		.replace(/"/g, '&quot;');
}

export function attachKniaQueueGlobals(win, $) {
	win.kniaQueueData = win.kniaQueueData || [];

	win.actualizarContadorKniaQueue = function actualizarContadorKniaQueue(count) {
		const n = typeof count === 'number' ? count : (win.kniaQueueData || []).length;
		const label = n > 0 ? `WA (${n})` : 'WA';
		$('.btn-knia-queue').text(label);
		$('#knia-queue-badge')
			.text(n > 0 ? String(n) : '')
			.toggle(n > 0);
	};

	win.cerrarModalKniaQueue = function cerrarModalKniaQueue() {
		$('#modal-knia-queue').remove();
	};

	win.mostrarModalKniaQueue = function mostrarModalKniaQueue(orders) {
		win.cerrarModalKniaQueue();
		const tasa = win.TASA_DOLAR || 1;
		const lista = Array.isArray(orders) ? orders : [];

		let rows = '';
		if (!lista.length) {
			rows = `<tr><td colspan="5" style="padding: 24px; text-align: center; color: #666;">No hay pedidos WhatsApp pendientes.</td></tr>`;
		} else {
			lista.forEach((order) => {
				const preview = (order.items_preview || [])
					.map((item) => `${item.qty}× ${item.name}`)
					.join(', ');
				const totalBs = (Number(order.total) || 0) * tasa;
				const phone = order.phone ? `<div style="font-size:12px;color:#555;">${escapeHtml(order.phone)}</div>` : '';
				const addr = order.address
					? `<div style="font-size:11px;color:#777;">${escapeHtml(order.address)}</div>`
					: '';
				const code = order.knia_code ? `<div style="font-size:11px;color:#25D366;">${escapeHtml(order.knia_code)}</div>` : '';
				rows += `
					<tr>
						<td style="padding:10px;border:1px solid #ddd;vertical-align:top;">
							<strong>${escapeHtml(order.customer_name || 'Cliente')}</strong>
							${phone}${addr}${code}
							<div style="font-size:11px;color:#999;margin-top:4px;">#${escapeHtml(order.number)} · ${escapeHtml(order.time || '')}</div>
						</td>
						<td style="padding:10px;border:1px solid #ddd;vertical-align:top;">${escapeHtml(order.tipo_label || order.tipo_servicio || '')}</td>
						<td style="padding:10px;border:1px solid #ddd;vertical-align:top;font-size:12px;">${escapeHtml(preview || `${order.items_count || 0} ítems`)}</td>
						<td style="padding:10px;border:1px solid #ddd;vertical-align:top;white-space:nowrap;">
							<strong>$${Number(order.total || 0).toFixed(2)}</strong>
							<div style="font-size:11px;color:#666;">Bs. ${totalBs.toFixed(2)}</div>
						</td>
						<td style="padding:10px;border:1px solid #ddd;text-align:center;vertical-align:top;">
							<button type="button" onclick="tomarPedidoKnia(${Number(order.order_id)})" style="background:#25D366;color:#fff;border:none;padding:8px 12px;border-radius:4px;cursor:pointer;font-weight:600;">Tomar</button>
						</td>
					</tr>`;
			});
		}

		const html = `
			<div class="modal-overlay" id="modal-knia-queue" style="display:flex;">
				<div class="modal-content" style="max-width:920px;width:96%;">
					<div class="modal-header">
						<div class="modal-title">Cola WhatsApp / Knia (${lista.length})</div>
						<button class="btn-cerrar" onclick="cerrarModalKniaQueue()">&times;</button>
					</div>
					<div style="max-height:560px;overflow-y:auto;">
						<table style="width:100%;border-collapse:collapse;">
							<thead>
								<tr style="background:#f5f5f5;">
									<th style="padding:10px;text-align:left;border:1px solid #ddd;">Cliente</th>
									<th style="padding:10px;text-align:left;border:1px solid #ddd;">Tipo</th>
									<th style="padding:10px;text-align:left;border:1px solid #ddd;">Pedido</th>
									<th style="padding:10px;text-align:left;border:1px solid #ddd;">Total</th>
									<th style="padding:10px;text-align:center;border:1px solid #ddd;">Acción</th>
								</tr>
							</thead>
							<tbody>${rows}</tbody>
						</table>
					</div>
					<div style="padding:12px;display:flex;justify-content:flex-end;gap:8px;">
						<button type="button" onclick="cargarColaKnia()" style="background:#607D8B;color:#fff;border:none;padding:10px 16px;border-radius:4px;cursor:pointer;">Actualizar</button>
						<button type="button" onclick="cerrarModalKniaQueue()" style="background:#6b7280;color:#fff;border:none;padding:10px 16px;border-radius:4px;cursor:pointer;">Cerrar</button>
					</div>
				</div>
			</div>`;
		$('body').append(html);
	};

	win.cargarColaKnia = function cargarColaKnia(openModal = true) {
		$.ajax({
			url: kniaAjaxUrl(win),
			type: 'POST',
			data: {
				action: 'poskn_get_knia_queue',
				nonce: kniaNonce(win),
				tienda_id: kniaTiendaId(win),
			},
			success(response) {
				if (!response || !response.success) {
					const msg =
						(response && response.data && response.data.message) || 'No se pudo cargar la cola WhatsApp';
					if (openModal) win.mostrarNotificacion(msg, 'error');
					return;
				}
				const orders = (response.data && response.data.orders) || [];
				win.kniaQueueData = orders;
				win.actualizarContadorKniaQueue(orders.length);
				if (openModal) win.mostrarModalKniaQueue(orders);
			},
			error() {
				if (openModal) win.mostrarNotificacion('Error de conexión al cargar cola WhatsApp', 'error');
			},
		});
	};

	win.verColaKnia = function verColaKnia() {
		win.cargarColaKnia(true);
	};

	win.tomarPedidoKnia = function tomarPedidoKnia(orderId) {
		const id = parseInt(orderId, 10);
		if (!id) return;
		if ((win.carrito || []).length > 0) {
			if (!window.confirm('Hay productos en el carrito. ¿Reemplazarlos con el pedido WhatsApp?')) {
				return;
			}
		}

		$.ajax({
			url: kniaAjaxUrl(win),
			type: 'POST',
			data: {
				action: 'poskn_get_order_items',
				nonce: kniaNonce(win),
				order_id: id,
			},
			success(response) {
				if (!(response && response.success && response.data && response.data.items)) {
					win.mostrarNotificacion(
						(response && response.data && response.data.message) || 'No se pudo cargar el pedido',
						'error'
					);
					return;
				}

				const data = response.data;
				const carrito = win.carrito || (win.carrito = []);
				const mapped = data.items.map((item) => ({
					id: item.product_id,
					originalId: item.product_id,
					name: item.name,
					price: parseFloat(item.price),
					cantidad: parseFloat(item.quantity),
					notas: item.notes || '',
					variacionId: item.variation_id || null,
					ckn: item.ckn || null,
					cknNames: item.ckn_names || [],
					enCocina: false,
					precioFijoKnia: true,
				}));
				carrito.splice(0, carrito.length, ...mapped);

				win.mesaSeleccionada = null;
				$('#mesa-badge').hide().text('');
				$('#mesa-seleccionada-compacto').hide();

				win.pedidoMesaAbierto = {
					order_id: id,
					status: data.status,
					canal: data.canal || 'knia',
					sin_mesa: true,
					knia_code: data.knia_code || '',
				};
				try {
					win.sessionStorage.setItem(
						'poskn_knia_abierto',
						JSON.stringify(win.pedidoMesaAbierto)
					);
				} catch (e) {
					/* ignore */
				}

				if (data.tipo_servicio && typeof win.seleccionarTipoServicio === 'function') {
					win.seleccionarTipoServicio(data.tipo_servicio);
				} else if (data.tipo_servicio) {
					win.modoServicioSeleccionado = data.tipo_servicio;
				}

				if (data.delivery_fee != null && $('#delivery-fee-input').length) {
					$('#delivery-fee-input').val(Number(data.delivery_fee) || 0).trigger('change');
				}

				if (data.cliente) {
					win.clienteSeleccionado = data.cliente;
					if (typeof win.mostrarClienteSeleccionado === 'function') {
						win.mostrarClienteSeleccionado();
					}
				} else if (typeof win.resetClienteSeleccion === 'function') {
					win.resetClienteSeleccion(true);
				}

				if (typeof win.actualizarCarrito === 'function') {
					win.actualizarCarrito();
				}

				win.cerrarModalKniaQueue();
				win.cargarColaKnia(false);
				const code = data.knia_code ? ` (${data.knia_code})` : '';
				win.mostrarNotificacion(
					`Pedido WhatsApp cargado${code}. Cobra y facture: al confirmar se completa y pasa a cocina.`,
					'success'
				);
			},
			error() {
				win.mostrarNotificacion('Error al tomar el pedido WhatsApp', 'error');
			},
		});
	};

	// Contador periódico (no abre modal).
	win.cargarColaKnia(false);
	setInterval(() => {
		if (typeof win.cargarColaKnia === 'function') win.cargarColaKnia(false);
	}, 20000);
}
